const navBarItems = [
  { name: 'student-list', },
  { name: 'donation-guide', },
  // { name: 'my-student-list', requiredAuth: true, },
]

export {
  navBarItems
}